import { Modal } from "antd";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { DynamicContent } from "../DynamicContent";
import { DynamicFilter } from "../DynamicFilter";
import { Box, LayoutWrapper } from "../styles";
import WidgetCard from "../WidgetCard";
import { userService } from "../../helpers/userService";
import React from "react";
import { swalError } from "../../../app/helpers/swal";
import { id } from "date-fns/locale";
import { WidgetCardV2 } from "../DynamicContent/WidgetCardV2";
const modalConfigData = {
  title: "Title",
  isModalOpen: false,
  modalWidth: 750,
  modalType: null,
};

export const GridDndComponent = ({
  data,
  customiseWidgets,
  handleLayout,
  handleChecked,
  userDashboardData,
  widgetCustomizeOpt,
  moduleInfo,
}) => {
  const [mounted, setMounted] = useState(false);
  const [layoutConfig, setLayoutConfig] = useState([]);
  const [modalConfig, setModalConfig] = useState(modalConfigData);
  const [tblView, setTblView] = useState(null);
  const [currentComponent, setCurrentComponent] = useState(null);
  const [mainData, setMainData] = useState([]);
  const userInfo = userService.userValue;
  const history = useHistory();
  const setMainDataFunc = () => {
    const layoutConfigFile = [];
    try {
      let idx = 0
      for (let el of data) {
        if (el.dnd_layout_config) {
          const newConfigFile = JSON.parse(el.dnd_layout_config);
          if (typeof el?.dnd_layout_config === "string") {
            layoutConfigFile.push(newConfigFile[0]);
          } else {
            layoutConfigFile.push(el?.newConfigFile[0]);
          }
          layoutConfigFile[idx].isDraggable = customiseWidgets;
          layoutConfigFile[idx].i = `${newConfigFile[0].i}`;
        }
        idx++;
      }
      // data?.map((el, idx) => {
      //   if (el.dnd_layout_config) {
      //     const newConfigFile = JSON.parse(el.dnd_layout_config);
      //     if (typeof el?.dnd_layout_config === "string") {
      //       layoutConfigFile.push(newConfigFile[0]);
      //     } else {
      //       layoutConfigFile.push(el?.newConfigFile[0]);
      //     }
      //     layoutConfigFile[idx].isDraggable = customiseWidgets;
      //     layoutConfigFile[idx].i = `${newConfigFile[0].i}`;
      //   }
      // });
      setLayoutConfig(layoutConfigFile);
      setMainData(data);
      setMounted(true);
    } catch (error) {
      swalError(error.message);
    }
  };

  useEffect(() => {
    setMainDataFunc();
  }, [customiseWidgets]);

  const handleCancelModal = () => {
    setModalConfig({ isModalOpen: false });
    history.push({
      pathname: `/`,
    });
  };
  const handleOptionClick = (optionName, title, item, widgetId) => {
    if (optionName === "fullscreen") {
      setModalConfig({
        isModalOpen: true,
        modalType: "fullscreen",
        modalWidth: 1040,
        title,
      });
    } else if (optionName === "filter") {
      setModalConfig({
        isModalOpen: true,
        modalType: "filter",
        modalWidth: 850,
        title: "Widget Filters",
      });
    } else if (
      optionName === "tblView" &&
      item.dashboard_widget_id === widgetId
    ) {
      setTblView(widgetId);
    } else if (
      optionName === "chartView" &&
      item.dashboard_widget_id === widgetId
    ) {
      setTblView(null);
    }

    setCurrentComponent(item);
  };
  return (
    <>
      <LayoutWrapper
				className="layout"
				layout={layoutConfig}
				cols={12}
				rowHeight={90}
				width={1080}
				items={mainData?.length}
				isResizable={!!widgetCustomizeOpt}
				useCSSTransforms={mounted}
				onLayoutChange={handleLayout}
			>
				{mainData?.map((el, idx) => {
					const newConfigFile = JSON.parse(el.dnd_layout_config);
					// if (el.widget_type === 'CardV2') {
					// 	return (
					// 		<Box key={`${newConfigFile[0].i}`}>
					// 			<div>
					// 				<WidgetCardV2
					// 					chartItem={el}
					// 					tblView={tblView}
					// 					currentComponent={currentComponent}
					// 					moduleInfo={moduleInfo}
					// 					cardModuleId={el?.module_id}
					// 					cardUserId={el?.user_id}
					// 					userInfo={userInfo}
					// 					widgetId={el?.dashboard_widget_id}
					// 				/>
					// 			</div>
					// 		</Box>
					// 	);
					// }
					return (
						<Box key={`${newConfigFile[0].i}`}>
							<WidgetCard
								cardTitle={el?.title ? el?.title : el.main_title}
								widgetId={el?.dashboard_widget_id}
								widgetType={el?.widget_type}
								handleOptionClick={(optionName, title, widgetId) =>
									handleOptionClick(optionName, title, el, widgetId)
								}
								customiseWidgets={customiseWidgets}
								tblView={tblView}
								moduleInfo={moduleInfo}
								cardModuleId={el?.module_id}
								cardUserId={el?.user_id}
								userInfo={userInfo}
							>
								<span className="Inner-Child" key={idx}>
									<DynamicContent
										chartItem={el}
										tblView={tblView}
										currentComponent={currentComponent}
									/>
								</span>
							</WidgetCard>
						</Box>
					);
				})}
			</LayoutWrapper>

      <Modal
        title={modalConfig.title}
        open={modalConfig.isModalOpen}
        width={modalConfig.modalWidth}
        footer={null}
        onCancel={handleCancelModal}
        className="custom-modal-header"
      >
        {currentComponent?.widget_type &&
          (() => {
            switch (modalConfig.modalType) {
              case "filter":
                return (
                  <div>
                    <DynamicFilter
                      slug={currentComponent.search_panel_slug}
                      currentComponent={currentComponent}
                      setCurrentComponent={setCurrentComponent}
                      moduleInfo={moduleInfo}
                      setModalConfig={setModalConfig}
                      setMainData={setMainData}
                      mainData={mainData}
                    />
                  </div>
                );
              case "fullscreen": {
                const newConfig = { ...currentComponent.widget_config };
                newConfig.height = 450;

                return (
                  <div>
                    <DynamicContent
                      chartItem={currentComponent}
                      tblView={tblView}
                    />
                  </div>
                );
              }
              default:
                return null;
            }
          })()}
      </Modal>
    </>
  );
};
